import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const VozidloNovy = lazy(() =>
  import('@/modules/vozidla/VozidloNovy').then((m) => ({ default: m.VozidloNovy })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/novy',
  component: () => (
    <Suspense fallback={null}>
      <VozidloNovy />
    </Suspense>
  ),
});
